export const SKINS = {
  standard: 'standard',
  dark: 'dark',
  inverted: 'inverted',
  destructive: 'destructive',
  success: 'success',
};

export const SHAPES = {
  square: 'square',
  round: 'round',
  pill: 'pill',
};

export const PRIORITY = {
  primary: 'primary',
};

export const iconChildSize = {
  tiny: '18px',
  small: '18px',
  medium: '24px',
  large: '24px',
};

const prefix = 'toggle-button';

export const dataHooks = {
  label: `${prefix}-label`,
  button: `${prefix}-button`,
};

export const dataAttr = {
  selected: 'data-selected',
  skin: 'data-skin',
  placement: 'data-placement',
  shape: 'data-shape',
};

export const testStories = {
  ToggleButton_SKINS: 'ToggleButton skins',
};

export const testDataHooks = {
  iconOfToggleButton: 'toggleButton-icon',
};

export const pillTextSizesMap = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'medium',
};
